module.exports = __webpack_public_path__ + "f7910ee3acfccd6dada3a60c4376a920.svg";